import React, { FC } from "react";
import { useMedia } from "react-use";

import { MEDIA_SIZE_SM } from "@/core/media";
import { IJobRequest } from "@/data/job-requests";
import { Flex, Header } from "@/eworkitComponents";
import { JobRequestClientAvatar } from "@/views/JobRequests/JobRequestClientAvatar/JobRequestClientAvatar";

import { JobRequestSubHeader } from "./JobRequestSubHeader";

import "./_job-request-icon-header.scss";

export interface IJobRequestIconHeaderProps {
  record: IJobRequest;
}

export const JobRequestIconHeader: FC<IJobRequestIconHeaderProps> = ({ record }) => {
  const isSmallScreen = useMedia(MEDIA_SIZE_SM);
  const baseClass = "job-request-icon-header";

  return (
    <Flex
      grow={0}
      direction={isSmallScreen ? "column" : "row"}
      innerMargin={isSmallScreen ? "sm" : "md"}
      className={`${baseClass}__container`}>
      <Flex justify={isSmallScreen ? "space-between" : "center"} align="flex-start" className="-flex-shrink-0">
        <JobRequestClientAvatar size="lg" jobRequest={record} />
      </Flex>
      <Flex grow={1} direction="column" justify="center" innerMargin={isSmallScreen ? "sm" : "xs"}>
        <Header
          tagType="h1"
          size={isSmallScreen ? "md" : "lg"}
          text={record.title}
          weight="bold"
          className={`${baseClass}__header`}
        />
        <JobRequestSubHeader record={record} />
      </Flex>
    </Flex>
  );
};
